var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 4.25001V4.25001C26.6635 4.25001 27.2453 4.25001 27.7143 4.40922C28.5975 4.70902 29.291 5.40252 29.5908 6.2857C29.75 6.75471 29.75 7.33648 29.75 8.50001L29.75 11.75C29.75 12.2214 29.75 12.4571 29.6036 12.6036C29.4571 12.75 29.2214 12.75 28.75 12.75L21.25 12.75M25.5 4.25001V4.25001C24.3365 4.25001 23.7547 4.25001 23.2857 4.40922C22.4025 4.70902 21.709 5.40252 21.4092 6.2857C21.25 6.75471 21.25 7.33648 21.25 8.50001L21.25 12.75M25.5 4.25001L8.25 4.25001C6.36438 4.25001 5.42157 4.25001 4.83579 4.8358C4.25 5.42158 4.25 6.36439 4.25 8.25001L4.25 29.75L8.5 28.3333L12.75 29.75L17 28.3333L21.25 29.75L21.25 12.75",
    stroke: "#3C4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 9.91675L15.5834 9.91675",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 15.5833H9.91665",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91669 21.25L14.1667 21.25",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.8765be2212a29e7ec1db29d61d9ed4ee.svg";
export { ForwardRef as ReactComponent };